import Marquee from "react-fast-marquee";

const items = [
  "Beacon IT Solution",
  "Pune, India",
  "Engineering since 2012",
  "CRM · eCommerce · APIs",
  "AI-augmented delivery",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="relative py-8 md:py-10 border-y border-hairline bg-[color:var(--bg)] overflow-hidden"
    >
      <Marquee gradient={false} speed={22} pauseOnHover>
        {items.map((it, i) => (
          <span
            key={`${it}-${i}`}
            className="font-display text-[10vw] md:text-[9vw] lg:text-[128px] leading-none tracking-[-0.04em] uppercase text-white/[0.08] mx-8"
          >
            {it}
            <span className="text-[color:var(--accent)]/70 ml-6">/</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
